import ChatIcon from '@mui/icons-material/ChatBubbleOutline';
import { Badge, IconButton, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
import { baseAtom, setUIStateIsOptionSelected } from '../../stores/jotai/base';

export default function MaterialAudioToggle(props) {
  const { unreadChats } = props;
  const [base, setBase] = useAtom(baseAtom);
  const theme = useTheme();
  return (
    <Tooltip title="Show/Hide Chat">
      <Badge
        classes={{ badge: "appbar-nav-item-badge white-badge-text" }}
        badgeContent={unreadChats}
        color="error"
      >
        <IconButton
          sx={{
            border: `1px solid ${theme.custom.borderGrey}`,
            borderRadius: "4px",
            padding: "4px",
            ":hover": {
              color: theme.custom.mainButtonHighlight,
              border: `1px solid ${theme.custom.mainButtonHighlight}`
            }
          }}
          onClick={() => {
            setUIStateIsOptionSelected(setBase, base, "chat");
          }}
        >
          <ChatIcon />
        </IconButton>
      </Badge>
    </Tooltip>
  );
}
